import React from "react";
import PropTypes from "prop-types";
import { SIZE_PICKER, OPTION_CLASS, LABEL, ICON_BUTTON } from "./Classes";
var SVG_STYLE = {
  height: "1em",
  width: "1em"
};

var SizePicker = function SizePicker(_ref) {
  var increase = _ref.increase,
      decrease = _ref.decrease;
  return React.createElement("div", {
    className: SIZE_PICKER + " " + OPTION_CLASS
  }, React.createElement("div", {
    className: LABEL
  }, "size"), React.createElement("button", {
    className: ICON_BUTTON,
    onClick: increase
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: "icon",
    style: SVG_STYLE
  }, React.createElement("polygon", {
    fill: "currentColor",
    points: "7.29 5.232 11.235 5.232 11.235 7.537 7.29 7.537 7.29 12.032 4.84 12.032 4.84 7.537 .874 7.537 .874 5.232 4.84 5.232 4.84 1.028 7.29 1.028"
  }))), React.createElement("button", {
    className: ICON_BUTTON,
    onClick: decrease
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: "icon",
    style: SVG_STYLE
  }, React.createElement("polygon", {
    fill: "currentColor",
    points: "7.19 5.237 11.069 5.237 11.069 7.615 7.19 7.615 4.782 7.615 .884 7.615 .884 5.237 4.782 5.237"
  }))));
};

SizePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  increase: PropTypes.func.isRequired,
  decrease: PropTypes.func.isRequired
} : {};
export default SizePicker;